/* Hooks, mit denen React-Komponenten den vorhandenen Zustand lesen (Sprache, Sitzung, verbundene Karte, Design). */
import { useEffect, useState, useSyncExternalStore } from 'react';
import I18n from '../i18n.ts';

/** Übersetzungsfunktion; die Komponente wird bei einem Sprachwechsel neu gezeichnet */
export function useT(): typeof I18n.t {
  useSyncExternalStore((cb) => I18n.onChange(cb), () => I18n.lang);
  return I18n.t;
}

/** Liest einen Speicher mit subscribe/getSnapshot (BackendSession, CloudLink) */
export function useStore<T>(store: { subscribe: (fn: () => void) => () => void; getSnapshot: () => T }): T {
  return useSyncExternalStore(store.subscribe, store.getSnapshot);
}

/** Wert mit Verzögerung: ändert sich erst, wenn er ms lang gleich blieb (für teure Berechnungen beim Tippen) */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => { const id = setTimeout(() => setV(value), ms); return () => clearTimeout(id); }, [value, ms]);
  return v;
}
